import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "./ToastProvider";

export const PENDING_PAYMENT_ORDER_KEY = "pending_payment_order_id";

/**
 * SkipCash sends the customer back to the return URL set in the merchant
 * portal with ?id=<paymentId>&statusId=<n>. Wherever that lands, route back to
 * the order being paid, which shows the result and refreshes the payment.
 */
export function PaymentReturnHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const { showToast } = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusId = params.get("statusId");
    if (!statusId || !params.get("id") || params.get("order")) return;

    // Only read here — the order page clears it once the return is handled.
    // (Clearing here breaks when the effect runs twice, e.g. React StrictMode.)
    let orderId: string | null = null;
    try {
      orderId = localStorage.getItem(PENDING_PAYMENT_ORDER_KEY);
    } catch {
      orderId = null;
    }

    if (orderId) {
      const paymentId = encodeURIComponent(params.get("id") ?? "");
      navigate(`/order/details?order=${orderId}&id=${paymentId}&statusId=${statusId}`, { replace: true });
      return;
    }

    // Paid straight from the email link, so we don't know which order this was
    if (statusId === "2") showToast("Payment successful. Thank you!", "success");
    else if (statusId === "3") showToast("Payment failed. Please try again.", "error");
    else if (statusId === "4") showToast("Payment cancelled.", "info");
    navigate("/order/track", { replace: true });
  }, [location.search, navigate, showToast]);

  return null;
}
